import React from "react";
import { cn } from "../../../lib/utils";

export interface EntityPopoverRowWithBadgeProps {
  title: string;
  badge?: string;
  secondaryText?: string;
  showDivider?: boolean;
}

const EntityPopoverRowWithBadge: React.FC<EntityPopoverRowWithBadgeProps> = ({
  title,
  badge,
  secondaryText,
  showDivider,
}) => {
  return (
    <div
      className={cn(
        "flex flex-col gap-1 px-2 py-[6px]",
        showDivider && "border-t border-[#E5E5E5]"
      )}
    >
      <div className="flex min-w-0 items-center gap-2">
        <span
          className="min-w-0 truncate text-[14px] font-normal text-[#0A0A0A]"
          title={title}
        >
          {title}
        </span>

        {badge && (
          <span
            className="min-w-0 max-w-[180px] truncate rounded-[8px] bg-[#F3F4F6] px-2 py-[2px] text-[12px] font-medium leading-4 text-[#4B5563]"
            title={badge}
          >
            {badge}
          </span>
        )}
      </div>

      {secondaryText && (
        <span
          className="min-w-0 max-w-[300px] truncate text-[14px] font-normal text-[#0A0A0A]"
          title={secondaryText}
        >
          {secondaryText}
        </span>
      )}
    </div>
  );
};

export default EntityPopoverRowWithBadge;